import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 md:mt-24 bg-primary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-heart-3-fill"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">爱情岛</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed max-w-md">
              爱情岛是一个专注爱情题材影视的综合平台，汇聚经典与热门的爱情电影、爱情电视剧资源，提供剧情介绍、分类筛选与在线播放演示体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movies" className="text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  关于爱情岛
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {["都市爱情", "青春校园", "治愈系", "异国之恋", "甜宠", "年代书信"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 text-xs rounded-md bg-background-50 text-secondary-800 border border-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 爱情岛 AIDAO · 本站所有内容均为演示数据，仅供学习与前端演示使用
          </p>
          <p className="text-xs text-foreground-500">
            播放功能仅为前端演示，不提供真实影片播放服务
          </p>
        </div>
      </div>
    </footer>
  );
}